import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { FormContext } from '../context/FormContext';
import languages from '../languages';
/**
 * @param {Array<string>} fieldsIds A list of fields ids
 * @returns {Array<import('./types').EcrionFormData>}
 */

var useFormFields = function useFormFields(fieldsIds) {
  /**
   * @type {[import('./types').EcrionFormState, any]}
   */
  var _React$useContext = React.useContext(FormContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  if (!fieldsIds) return [];
  return fieldsIds.map(function (fieldId) {
    var field = state.fields[fieldId];
    var meta = state.meta[fieldId];
    var data = state.data[fieldId];
    var translatedProperties = languages.translate(state, field);
    return _objectSpread({
      value: data
    }, field, translatedProperties, meta, {
      dispatch: dispatch
    });
  });
};

export default useFormFields;